<template>
    <div>
      <page-head
        :title="title"
        :btn-list="btnList"
        :show-back="false"
        @handleBtn="handleBtn"
      ></page-head>
      <div class="content">
        <div class="search">
          <i-form ref="search" :model="query">
            <row :gutter="80">
              <i-col span="6">
                <form-item label="统一社会信用代码" prop="usc_code">
                  <Input
                    v-model="query.usc_code"
                    clearable
                    placeholder="请输入统一社会信用代码"
                  />
                </form-item>
              </i-col>
              <i-col span="6">
                <form-item label="社会组织名称" prop="org_name">
                  <Input
                    v-model="query.org_name"
                    clearable
                    placeholder="请输入社会组织名称"
                  />
                </form-item>
              </i-col>
            </row>
          </i-form>
        </div>
        <div class="table-data">
          <div class="bottomtable">
            <i-table
              :columns="tableHeader"
              :border="true"
              :loading="isLoading"
              :data="info"
              stripe
              ref="table"
              height="500"
            >
              <template slot-scope="{ row, index }" slot="action"> </template>
            </i-table>
          </div>
        </div>
      </div>
  
      <!-- <div class="content" v-if="info">
        <div class="search">
          <Form>
            <row :gutter="80" v-for="itme in info">
              <i-col span="8" v-for="(data, key) in itme">
                <FormItem :label="key + ':'">
                  <div class="detail">{{ data }}</div>
                </FormItem>
              </i-col>
            </row>
          </Form>
        </div>
      </div> -->
    </div>
  </template>
  
  <script>
  import pageHead from "../../../components/head";
  import api from "../../../api/index";
  const { mzbJjhfr } = api;
  export default {
    name: "marriageRegister",
    components: {
      pageHead,
    },
  
    data() {
      return {
        query: {
          org_name: "",
          usc_code: "",
        },
        info: undefined,
        isLoading: false,
        tableHeader: [
            {title: "社会组织名称",key: "Org_Name",align: "center"},
            {title: "统一社会信用代码",key: "Unified_Code",align: "center"},
            {title: "业务范围",key: "BUSINESS_SCOPE",align: "center"},
            {title: "法定代表人",key: "LEGAL_NAME",align: "center"},
            {title: "注册资金",key: "男方身份证件类型",align: "center"},
            {title: "女方姓名",key: "女方姓名",align: "center"},
            {title: "女方身份证件号码",key: "女方身份证件号码",align: "center"},
            {title: "女方身份证件类型",key: "女方身份证件类型",align: "center"},
            {title: "登记日期",key: "登记日期",align: "center"},
          //   {title: "原登记日期",key: "原登记日期",align: "center"},
        ],
        title: "民办非企业单位登记证书查询",
        btnList: [
          {
            name: "重置",
            type: "reset",
          },
          {
            name: "查询",
            type: "search",
          },
        ],
      };
    },
    methods: {
      handleBtn(type) {
        if (type == "reset") {
          this.query.usc_code = "";
          this.query.org_name = "";
  
          this.$refs.search.resetFields();
        } else if (type == "search") {
          this.marriageRegister();
        }
      },
      async marriageRegister() {
        if (!this.query.usc_code) {
          return this.$Message.warning("请输入统一社会信用代码");
        }
        if (!this.query.org_name) {
          return this.$Message.warning("请输入社会组织名称");
        }
        this.isLoading = true;
        try {
          let data = {
            org_name: this.query.org_name,
            usc_code: this.query.usc_code,
            clientName:'中心',
            start:1,
            limit:1
          };
          console.log(data);
          let res = await this.$get(mzbJjhfr, data);
          console.log(JSON.parse(res));
          if (res) {
            this.info = JSON.parse(res).body.data;
          } else {
            this.info = undefined;
          }
        } finally {
          this.isLoading = false;
        }
        console.log(this.query);
      },
    },
    created() {},
    mounted() {},
  };
  </script>
  
  <style lang="less" scoped>
  .content {
    margin: 20px;
  }
  
  .search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
  }
  
  .label {
    width: 100px;
  }
  
  .time {
    width: 100%;
  }
  </style>
  